<template lang="pug">
aside.ai-chat-sidebar
	.sidebar-head
		h2 My Chats
	HaqTextField(v-model="query" placeholder="Find chat" append-icon="mdi-magnify" hide-details)
	v-btn.haq-btn.haq-btn-primary.new-chat(@click="$emit('new-chat')")
		v-icon(left) mdi-plus
		| New Chat
	.sidebar-list
		template(v-for="bucket in buckets")
			section.bucket(v-if="bucket.items.length" :key="bucket.label")
				p.bucket-label {{ bucket.label }}
				ul.conv-list
					li(v-for="c in bucket.items" :key="c.objectId")
						button.conv(
							type="button"
							:class="{ 'is-active': c.objectId === selectedId }"
							:title="conversationTitle(c)"
							@click="$emit('select', c.objectId)"
						)
							v-icon.conv-icon mdi-message-outline
							span.conv-name {{ conversationTitle(c) }}
							span.when {{ formatChatWhen(c.updatedAt || c.createdAt) }}
		p.empty(v-if="!filtered.length") {{ query ? 'No matching chats' : 'No chats yet' }}
</template>
<script>
import HaqTextField from '@/components/form/HaqTextField.vue';

/**
 * Left My Chats rail: search, New Chat, and time-bucketed history.
 */
export default {
	name: 'AiChatSidebar',
	components: { HaqTextField },
	props: {
		conversations: { type: Array, default: function() { return []; } },
		selectedId: { type: String, default: null }
	},
	data() {
		return { query: '' };
	},
	computed: {
		/**
		 * Conversations matching the search box.
		 * @returns {Array}
		 */
		filtered() {
			const q = (this.query || '').toLowerCase().trim();
			const list = Array.isArray(this.conversations) ? this.conversations : [];
			if (!q) return list;
			return list.filter(function(c) {
				return String(c.title || '').toLowerCase().indexOf(q) >= 0;
			});
		},
		/**
		 * Today / Yesterday / Previous 7 Days / Earlier groups.
		 * @returns {Array}
		 */
		buckets() {
			const now = new Date();
			const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
			const startYesterday = startToday - 86400000;
			const startWeek = startToday - 7 * 86400000;
			const groups = {
				Today: [],
				Yesterday: [],
				'Previous 7 Days': [],
				Earlier: []
			};
			const list = this.filtered.slice().sort(function(a, b) {
				return new Date(b.updatedAt || b.createdAt).getTime() - new Date(a.updatedAt || a.createdAt).getTime();
			});
			for (let i = 0; i < list.length; i++) {
				const row = list[i];
				const t = new Date(row.updatedAt || row.createdAt).getTime();
				if (t >= startToday) groups.Today.push(row);
				else if (t >= startYesterday) groups.Yesterday.push(row);
				else if (t >= startWeek) groups['Previous 7 Days'].push(row);
				else groups.Earlier.push(row);
			}
			return [
				{ label: 'Today', items: groups.Today },
				{ label: 'Yesterday', items: groups.Yesterday },
				{ label: 'Previous 7 Days', items: groups['Previous 7 Days'] },
				{ label: 'Earlier', items: groups.Earlier }
			];
		}
	},
	methods: {
		/**
		 * Display title for a conversation row.
		 * @param {object} conversation
		 * @returns {string}
		 */
		conversationTitle(conversation) {
			const title = conversation && conversation.title;
			return (title && String(title).trim()) || 'New Chat';
		},
		/**
		 * Clock time for today/yesterday; short date for older chats.
		 * @param {string|Date} value
		 * @returns {string}
		 */
		formatChatWhen(value) {
			if (!value) return '';
			const d = new Date(value);
			if (Number.isNaN(d.getTime())) return '';
			const now = new Date();
			const startToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
			const startYesterday = startToday - 86400000;
			if (d.getTime() >= startYesterday) {
				return d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
			}
			return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
		}
	}
};
</script>
